export default "__VITE_ASSET__DB1ei1lM__"